module.exports = __webpack_public_path__ + "static/media/promulgation-landing-social-media.cd468319.png";